import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';


// Shows its content on click
export const ClickTooltip = ({content, sx = {}, ...props}) => {
    const [open, setOpen] = React.useState(false);

    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        setOpen(true);
    };

    return (
        <ClickAwayListener onClickAway={handleTooltipClose}>
            <div>
                <Tooltip
                    onClose={handleTooltipClose}
                    open={open}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={content}
                    slotProps={{
                        popper: {
                            disablePortal: true,
                        },
                    }}
                    sx={{...sx}}
                    {...props}
                >
                    <IconButton onClick={handleTooltipOpen}>
                        <InfoOutlinedIcon/>
                    </IconButton>
                </Tooltip>
            </div>
        </ClickAwayListener>
    );
}


// Shows its content when the mouse is hoovered over it
export const HooverTooltip = ({content, sx = {}, ...props}) => {
    return (
        <div>
            <Tooltip
                disableFocusListener
                disableTouchListener
                title={content}
                sx={{...sx}}
                {...props}
            >
                <IconButton>
                    <InfoOutlinedIcon/>
                </IconButton>

            </Tooltip>
        </div>
    );
}


export const EmptyTooltipPlaceholder = ({sx = {}, ...props}) => {
    return (
        <IconButton
            disabled
            sx={{
                visibility: 'hidden', // hides it visually, but it still takes space
                ...sx,
            }}
            {...props}
        >
            <InfoOutlinedIcon/>
        </IconButton>
    );
};

